import {Button} from 'platform/components';
import {Show, Spinner, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

type InfiniteScrollFooterStatusProps = TestIdProps & {
  showRetry: boolean;
  showSpinner: boolean;
  showComplete: boolean;
  isFetching: boolean;
  onRetry: VoidFunction;
  completeText: string;
  compact?: boolean;
};

export function InfiniteScrollFooterStatus(props: InfiniteScrollFooterStatusProps) {
  return (
    <>
      <Show when={props.showRetry}>
        <Button
          data-testid={suffixTestId('retryButton', props)}
          title={i18n.t('general.actions.retry')}
          variant="secondary"
          onClick={props.onRetry}
          isLoading={props.isFetching}
        />
      </Show>
      <Show when={props.showSpinner}>
        <Spinner data-testid={suffixTestId('nextPageSpinner', props)} />
      </Show>
      <Show when={props.showComplete}>
        <Text
          size={props.compact ? 'xSmall' : 'small'}
          color={props.compact ? 'secondary' : 'tertiary'}
        >
          {props.completeText}
        </Text>
      </Show>
    </>
  );
}
